(function(){
const root=document.getElementById('ssIntro');
if(!root)return;
function toInt(value,fallback,min,max){
const n=parseInt(value,10);
if(Number.isNaN(n))return fallback;
return Math.min(Math.max(n,min),max);
}
function speedRange(speed){
if(speed==='slow')return{stepMin:.18,stepMax:.32,durationMin:.66,durationMax:.96};
if(speed==='fast')return{stepMin:.08,stepMax:.16,durationMin:.42,durationMax:.66};
return{stepMin:.13,stepMax:.24,durationMin:.54,durationMax:.82};
}
const enabled=root.dataset.enabled!=='false';
if(!enabled){root.remove();return;}
const introCountKey='ssIntroShownCount';
const introLimit=toInt(root.dataset.limit,3,0,5);
if(introLimit<=0){root.remove();return;}
const isShopifyEditor=window.Shopify&&window.Shopify.designMode;
const currentCount=isShopifyEditor?0:toInt(sessionStorage.getItem(introCountKey),0,0,999);
if(currentCount>=introLimit){
root.remove();
return;
}
if(!isShopifyEditor){
sessionStorage.setItem(introCountKey,String(currentCount+1));
}
const word=root.dataset.word||'StitchandSew';
const countByIntro=[
toInt(root.dataset.count1,13,0,30),
toInt(root.dataset.count2,9,0,30),
toInt(root.dataset.count3,3,0,30),
toInt(root.dataset.count4,0,0,30),
toInt(root.dataset.count5,0,0,30)
];
const topCountByIntro=[
toInt(root.dataset.topCount1,4,0,10),
toInt(root.dataset.topCount2,3,0,10),
toInt(root.dataset.topCount3,2,0,10),
toInt(root.dataset.topCount4,0,0,10),
toInt(root.dataset.topCount5,0,0,10)
];
const count=countByIntro[currentCount]||0;
const topCount=Math.min(topCountByIntro[currentCount]||0,count);
if(count<=0){root.remove();return;}
const speed=speedRange(root.dataset.letterSpeed||'standard');
const placed=[];
function rand(min,max){
return Math.random()*(max-min)+min;
}
function farEnough(x,y){
return placed.every(function(p){
const dx=p.x-x;
const dy=p.y-y;
return Math.sqrt(dx*dx+dy*dy)>18;
});
}
function topWeightedPoint(){
const zones=[
[2,18,1.5,8.5],[24,42,1.2,8],[48,62,1.5,8.8],[68,82,1.2,8],[86,98,1.5,8.5]
];
const z=zones[Math.floor(Math.random()*zones.length)];
return{x:rand(z[0],z[1]),y:rand(z[2],z[3])};
}
function edgeWeightedPoint(){
const zones=[
[3,18,2,20],[25,42,2,18],[58,75,2,20],[82,97,2,22],
[4,18,30,48],[30,46,30,50],[56,72,30,50],[82,96,32,52],
[3,18,60,78],[25,42,62,82],[58,75,60,80],[82,97,62,84],
[8,26,82,96],[38,58,80,96],[72,94,82,96]
];
const z=zones[Math.floor(Math.random()*zones.length)];
return{x:rand(z[0],z[1]),y:rand(z[2],z[3])};
}
for(let i=0;i<count;i++){
let x,y,tries=0;
do{
const point=i<topCount?topWeightedPoint():edgeWeightedPoint();
x=point.x;
y=point.y;
tries++;
}while(!farEnough(x,y)&&tries<80);
placed.push({x,y});
const group=document.createElement('div');
group.className='ss-intro__scatter';
group.style.setProperty('--ss-left',x.toFixed(2)+'%');
group.style.setProperty('--ss-top',y.toFixed(2)+'%');
group.style.setProperty('--ss-delay',rand(0,.12).toFixed(2)+'s');
group.style.setProperty('--ss-step',rand(speed.stepMin,speed.stepMax).toFixed(2)+'s');
group.style.setProperty('--ss-duration',rand(speed.durationMin,speed.durationMax).toFixed(2)+'s');
word.split('').forEach(function(letter,index){
const span=document.createElement('span');
span.textContent=letter;
span.style.animationDelay='calc(var(--ss-delay) + var(--ss-step) * '+index+')';
group.appendChild(span);
});
root.appendChild(group);
}
})();
